var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgLogoHuma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 54,
    viewBox: "0 0 191 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5915 25.2549H44.3163V29.7628H57.5915V25.2549Z",
    fill: "#B246FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1041 13.1792C47.3924 11.2163 40.0734 14.4038 37.0251 20.9609C33.9767 27.518 36.244 35.1971 42.0534 39.101L48.9904 24.179L54.1041 13.1792Z",
    fill: "url(#paint0_linear_2_382)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8952 14.899C63.7046 18.803 65.9719 26.482 62.9235 33.0392C59.8751 39.5963 52.5563 42.7837 45.8445 40.8209L52.7815 25.8988L57.8952 14.899Z",
    fill: "url(#paint1_linear_2_382)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.034 38.2548C102.345 38.2548 101.381 37.9551 100.056 37.3556C98.9841 36.6007 98.1254 35.7252 97.5221 34.8188C96.7954 33.727 96.432 31.9308 96.432 31.0938V23.481L101.788 22.5203V30.9974C101.788 31.5416 101.98 32.2051 102.365 32.6118C102.771 32.9971 103.533 33.2453 104.132 33.2453C104.709 33.2453 105.504 32.9971 105.868 32.6118C106.252 32.2051 106.445 31.6389 106.445 30.9974V22.8146L111.77 21.827V31.0938C111.77 32.2226 111.406 33.759 110.68 34.8508C109.974 35.9212 109.233 36.7562 107.951 37.3556C106.668 37.9551 105.701 38.2548 104.034 38.2548Z",
    fill: "#423B46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.1 21.5209C123.789 21.5209 124.559 21.8205 125.884 22.4199C126.956 23.1748 127.815 24.0504 128.418 24.9568C129.145 26.0486 129.508 27.8448 129.508 28.6817V37.8657H124.152V28.7782C124.152 28.0717 123.96 27.515 123.575 27.1083C123.169 26.723 122.667 26.5303 122.068 26.5303C121.491 26.5303 121.021 26.723 120.658 27.1083C120.273 27.515 120.081 28.0717 120.081 28.7782V37.8657H114.755V28.6817C114.755 27.5529 115.119 26.0165 115.845 24.9247C116.551 23.8543 117.292 23.0194 118.574 22.4199C119.857 21.8205 120.433 21.5209 122.1 21.5209Z",
    fill: "#423B46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.848 21.5209C133.536 21.5209 134.306 21.8205 135.631 22.4199C136.703 23.1748 137.562 24.0504 138.165 24.9568C138.892 26.0486 139.256 27.8448 139.256 28.6817V37.8657H133.9V28.7782C133.9 28.0717 133.707 27.515 133.322 27.1083C132.916 26.723 132.414 26.5303 131.816 26.5303C131.238 26.5303 130.768 26.723 130.405 27.1083C130.02 27.515 129.828 28.0717 129.828 28.7782V37.8657H124.502V28.6817C124.502 27.5529 124.866 26.0165 125.593 24.9247C126.298 23.8543 127.039 23.0194 128.322 22.4199C129.604 21.8205 130.18 21.5209 131.848 21.5209Z",
    fill: "#423B46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.278 36.054C153.862 37.1962 152.06 37.8803 150.097 37.8803C145.543 37.8803 141.85 34.1946 141.85 29.6481C141.85 25.1015 145.543 21.4159 150.097 21.4159C152.08 21.4159 153.899 22.1141 155.321 23.2778L159.955 22.4154V37.8801H155.278V36.054ZM153.935 29.707C153.935 31.8026 152.233 33.5013 150.134 33.5013C148.035 33.5013 146.333 31.8026 146.333 29.707C146.333 27.6114 148.035 25.9126 150.134 25.9126C152.233 25.9126 153.935 27.6114 153.935 29.707Z",
    fill: "#423B46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2787 15.8779H73.4309V37.8658H79.2787V15.8779Z",
    fill: "#423B46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9235 15.8779H87.0757V37.8658H92.9235V15.8779Z",
    fill: "#423B46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.55 24.1649L76.7302 26.2454L77.4749 30.4611L89.2946 28.3807L88.55 24.1649Z",
    fill: "#423B46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_382",
    x1: 52.9426,
    y1: 15.6777,
    x2: 17.5458,
    y2: 11.3729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_382",
    x1: 56.7338,
    y1: 17.3975,
    x2: 82.8728,
    y2: 41.7433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoHuma);
export default __webpack_public_path__ + "static/media/img-logo-huma.771b1a54adbdedb4b74ac393016db50d.svg";
export { ForwardRef as ReactComponent };